/**
 * /text-shortener — уложить текст в НАЗВАННОЕ число и увидеть, чем за это
 * заплачено. Вторая редакция 2026-10-03.
 *
 * ЗАДАЧА, А НЕ ЖАНР. За «сократить текст» стоят две ситуации, и страница
 * обслуживает обе одной строкой «Сократить до [ N ] [знаков | слов | предл. | %]»:
 *   • предела нет, нужно «короче» — по умолчанию цель 75 % исходного, и вставка
 *     сразу показывает результат (так ищут чаще всего: «сократить текст без
 *     потери смысла», Вордстат 2026-10-02);
 *   • предел есть — 280 в посте, 70 в SMS с кириллицей, 250 слов в аннотации,
 *     3 предложения. Фишки лимитов называют ситуацию, а не число.
 *
 * ОДИН ХОЛСТ, ТРИ ВИДА: «Текст» — что вы дали, «Правка» — что с ним сделано,
 * «Итог» — что получите. Вкладки стоят всегда (недоступные приглушены): в
 * первой редакции они появлялись после вставки и сдвигали всё под собой —
 * обращение Фарида 2026-10-03 «страница скачет». Правило этой редакции:
 * ничто, что меняет размеры, не появляется и не исчезает — меняется только
 * содержимое мест постоянного размера.
 *
 * ЛЕСТНИЦА СПРАВА. Пять ступеней цены смысла (обороты → усилители → вводные →
 * скобки → предложения) и шестая — пересказ нейросетью. Переключатель на
 * ступени запрещает её целиком, и план ищет недостающее на других.
 *
 * ПЕРЕСКАЗ — ОТДЕЛЬНОЕ ОБЕЩАНИЕ. Выбор предложений хорош, пока сжимать надо
 * в разы немного; сказка в 6644 знака, сжатая до 1093, теряла развязку
 * (замер 2026-10-03). Там нужен пересказ — он идёт через лейн /paraphraser
 * (действие `fit`, токены по цене за символ, цена видна до нажатия), а
 * движок страницы дотягивает ответ модели до точного числа. Слова в нём уже
 * не авторские — это сказано на экране, и «Вернуть мой текст» стоит рядом.
 * Суточный счётчик пересказ не трогает: работа за токены упирается только в
 * кошелёк (TokenWorkHasNoPersonalDailyLimitTest).
 *
 * ЯЗЫК — ТЕКСТА, А НЕ СТРАНИЦЫ. Английский текст на /ru/ получает английские
 * правила (TSTrim.detectLang).
 */
(function () {
    'use strict';

    var CFG = window.__TS_CFG || {};
    var I = CFG.i18n || {};
    var AI = CFG.ai || {};
    var LOC = String(CFG.locale || 'ru');
    var PAGE_LANG = LOC.slice(0, 2);
    var SLUG = 'text-shortener';
    var CLASSES = ['wordy', 'filler', 'hedge', 'aside', 'sent'];

    function $(id) { return document.getElementById(id); }
    function t(k, f) { return I[k] || f || ''; }
    function fill(s, map) {
        return String(s || '').replace(/:([a-z]+)/g, function (m, k) {
            return Object.prototype.hasOwnProperty.call(map, k) ? map[k] : m;
        });
    }
    function toast(m, kind) { if (window.__toast && m) window.__toast(m, kind || 'info'); }
    function ae(f, p) {
        try { if (window.__ae) window.__ae('feature_use', Object.assign({ slug: SLUG, f: f }, p || {})); }
        catch (e) {}
    }
    var _seen = {};
    var STAGE = { pasted: 'editing', shortened: 'complete' };
    function funnel(stage, p) {
        if (_seen[stage]) return;
        _seen[stage] = 1;
        try { if (window.__aeFunnel) window.__aeFunnel(stage, p || {}); } catch (e) {}
        try { if (window.__stage && STAGE[stage]) window.__stage(STAGE[stage], { tool: SLUG }); } catch (e) {}
    }
    function settings() { return window.__toolSettings || null; }
    function load(k, fb) { var s = settings(); return s ? s.load(SLUG, k, fb) : fb; }
    function save(k, v) { var s = settings(); if (s) s.save(SLUG, k, v); }

    var COARSE = false;
    try { COARSE = window.matchMedia('(pointer:coarse)').matches; } catch (e) {}

    var PLURAL = null;
    try { PLURAL = new Intl.PluralRules(LOC); } catch (e) { PLURAL = null; }
    /** «знак|знака|знаков» → форма по числу; двух форм хватает языкам без «few». */
    function plural(n, forms) {
        var p = String(forms || '').split('|');
        if (p.length < 2) return p[0] || '';
        var c = PLURAL ? PLURAL.select(n) : (n === 1 ? 'one' : 'other');
        if (p.length === 2) return c === 'one' ? p[0] : p[1];
        return c === 'one' ? p[0] : (c === 'few' ? p[1] : p[2]);
    }
    function fmt(n) {
        try { return Number(n).toLocaleString(LOC); } catch (e) { return String(n); }
    }

    var S = {
        mode: 'edit',          // edit | diff | clean — что сейчас на холсте
        view: load('view', 'diff') === 'clean' ? 'clean' : 'diff',   // куда вести после сокращения
        src: '',               // исходник, к которому привязаны позиции правок
        plan: null,
        drop: {},              // индексы выброшенных предложений
        mine: {},              // предложения, которые человек трогал сам — не сворачиваются
        open: {},              // развёрнутые пометки «убрано N предложений»
        off: {},               // ступени, запрещённые человеком
        touched: false,
        manual: false,         // итог поправлен руками
        manualText: '',
        ticket: null, ticketKey: null, delivered: false, busy: false,
        lang: PAGE_LANG,
        goal: { n: 75, u: 'percent', r: null, p: null },
        ai: null,              // { prev, key, cost, balance } — на холсте пересказ
        aiBusy: false,
        aiMsg: null,           // отказ лейна пересказа — до следующего действия
        note: null,            // разовое сообщение { text, until }
        copiedUntil: 0,
    };
    (function restore() {
        var off = load('off', null);
        if (off && typeof off === 'object') CLASSES.forEach(function (c) { if (off[c]) S.off[c] = true; });
        var g = load('goal', null);
        if (g && typeof g === 'object' && /^(chars|words|sentences|percent)$/.test(g.u) && +g.n > 0) {
            S.goal = { n: Math.round(+g.n), u: g.u, r: g.r === 'x' || g.r === 'sms' ? g.r : null, p: g.p || null };
        }
    })();

    // ── цель ─────────────────────────────────────────────────────────────

    /** Единица счёта плана: проценты сводятся к знакам. */
    function countUnit() { return S.goal.u === 'percent' ? 'chars' : S.goal.u; }
    function rule() { return S.goal.u === 'chars' ? S.goal.r : null; }

    function sizeOf(text, u, r) {
        u = u || countUnit();
        if (window.TSPlan) return window.TSPlan.size(text, u, S.lang, u === 'chars' ? (r === undefined ? rule() : r) : null);
        return String(text || '').length;
    }
    /** Цель в единицах счёта для данного исходника. */
    function goalFor(src) {
        if (S.goal.u === 'percent') return Math.max(1, Math.round(String(src || '').length * Math.min(100, S.goal.n) / 100));
        return Math.max(1, S.goal.n);
    }
    function unitForms(u) { return u === 'words' ? t('u_words') : (u === 'sentences' ? t('u_sent') : t('u_chars')); }

    /* SMS: предел зависит от алфавита ТЕКСТА, поэтому пересчитывается при
       каждой смене текста, пока выбран этот лимит. */
    function syncRuleTarget(text) {
        if (S.goal.r !== 'sms' || !window.TSPlan) return false;
        var info = window.TSPlan.smsInfo(text || defaultSmsProbe());
        if (S.goal.n === info.limit) return false;
        S.goal.n = info.limit;
        return true;
    }
    /* Пустое поле на русской странице — почти наверняка будущая кириллица. */
    function defaultSmsProbe() { return /^(ru|uk|ko|ar)$/.test(PAGE_LANG) ? 'я' : 'a'; }

    function setGoal(n, u, r, p, why) {
        var prev = S.goal.n + ':' + S.goal.u + ':' + S.goal.r;
        S.goal = { n: Math.max(1, Math.round(+n || 1)), u: u, r: u === 'chars' ? (r || null) : null, p: p || null };
        if (S.goal.u === 'percent') S.goal.n = Math.min(100, S.goal.n);
        syncRuleTarget(sourceText());
        save('goal', S.goal);
        S.aiMsg = null;
        syncGoalUi();
        updateMeter();
        paintOverflow();
        renderMsg();
        syncAi();
        if (prev !== S.goal.n + ':' + S.goal.u + ':' + S.goal.r && S.plan) {
            if (why === 'range') schedulePlan(true);
            else if (why === 'number') schedulePlan(false);
            else replan();
        }
    }

    /** Разумное число для новой единицы: от текста, если он есть. */
    function defaultFor(u) {
        var src = sourceText();
        if (!src.trim() || !window.TSPlan) return { chars: 1000, words: 250, sentences: 3, percent: 75 }[u];
        if (u === 'percent') return 75;
        var full = window.TSPlan.size(src, u, S.lang, null);
        if (u === 'sentences') return Math.max(1, Math.round(full / 2));
        var v = Math.max(1, Math.round(full * 0.75));
        return u === 'chars' && v > 100 ? Math.round(v / 10) * 10 : v;
    }

    function syncGoalUi() {
        var num = $('tsTarget');
        if (num && document.activeElement !== num) num.value = String(S.goal.n);
        if (num) num.max = S.goal.u === 'percent' ? '100' : '200000';
        document.querySelectorAll('#tsUnits [data-u]').forEach(function (b) {
            var on = b.getAttribute('data-u') === S.goal.u;
            b.setAttribute('aria-checked', on ? 'true' : 'false');
            b.tabIndex = on ? 0 : -1;
        });
        document.querySelectorAll('[data-preset]').forEach(function (b) {
            b.setAttribute('aria-pressed', b.getAttribute('data-preset') === S.goal.p ? 'true' : 'false');
        });
        document.querySelectorAll('.ts-pv').forEach(function (row) {
            if (row.getAttribute('data-k') === S.goal.p) row.setAttribute('aria-current', 'true');
            else row.removeAttribute('aria-current');
        });
    }

    // ── чтение и запись холста ───────────────────────────────────────────

    /**
     * Текст холста читается ОБХОДОМ узлов, а не через innerText: те же смещения
     * потом адресуют правки, и расхождение в один символ рисует подсветку не
     * там. Замерено 2026-08-26 на Chromium, Firefox и WebKit: при
     * `contenteditable="plaintext-only"` и `white-space: pre-wrap` перевод
     * строки хранится НАСТОЯЩИМ «\n» в текстовом узле. Ветка BR — на случай
     * вставки, которая всё-таки принесёт элемент.
     */
    function scan(root) {
        var parts = [], nodes = [], len = 0;
        if (!root) return { text: '', nodes: nodes };
        var w = document.createTreeWalker(root, NodeFilter.SHOW_TEXT | NodeFilter.SHOW_ELEMENT, null);
        var n;
        while ((n = w.nextNode())) {
            if (n.nodeType === 3) {
                nodes.push({ n: n, at: len, len: n.data.length });
                parts.push(n.data);
                len += n.data.length;
            } else if (n.nodeName === 'BR') {
                parts.push('\n');
                len += 1;
            }
        }
        return { text: parts.join(''), nodes: nodes };
    }

    function editorText() {
        var ed = $('tsEd');
        return ed ? scan(ed).text.replace(/\r\n?/g, '\n') : '';
    }
    function setEditorText(text) {
        var ed = $('tsEd');
        if (ed) ed.textContent = String(text || '');
    }
    function editMode() {
        var ed = $('tsEd');
        if (ed) { ed.setAttribute('contenteditable', 'plaintext-only'); ed.dataset.mode = 'edit'; }
        S.mode = 'edit';
    }
    /** Текст, который человек получит. */
    function resultText() {
        if (!S.plan) return editorText();
        if (S.manual) return S.manualText;
        return assemble();
    }
    function sourceText() { return S.mode === 'edit' ? editorText() : S.src; }
    /** В «Тексте» исходник поправлен после сокращения — правка относится к прежнему. */
    function stale() { return !!S.plan && S.mode === 'edit' && editorText() !== S.src; }

    // ── хвост за лимитом ─────────────────────────────────────────────────

    /**
     * Всё, что не влезает, гаснет ПРЯМО В ТЕКСТЕ ещё до нажатия — Custom
     * Highlight API, без единого элемента. Для слов и предложений граница —
     * конец N-го слова или предложения; для правил площадок — по их весам.
     */
    var HL = 'ts-over';
    function paintOverflow() {
        var api = window.CSS && CSS.highlights && window.Highlight;
        if (!api) return;
        try { CSS.highlights.delete(HL); } catch (e) { return; }
        if (S.mode !== 'edit') return;
        var ed = $('tsEd');
        if (!ed) return;
        var s = scan(ed);
        var cut = cutOffset(s.text);
        if (cut === null || cut >= s.text.length) return;
        var r = document.createRange(), started = false, last = null;
        for (var i = 0; i < s.nodes.length; i++) {
            var it = s.nodes[i];
            if (!started && cut >= it.at && cut <= it.at + it.len) { r.setStart(it.n, cut - it.at); started = true; }
            last = it;
        }
        if (!started || !last) return;
        r.setEnd(last.n, last.len);
        try { CSS.highlights.set(HL, new Highlight(r)); } catch (e) {}
    }

    function cutOffset(text) {
        var u = countUnit(), lim = goalFor(text);
        if (u === 'chars') {
            var r = rule();
            if (!r) return text.length > lim ? lim : null;
            if (sizeOf(text, 'chars', r) <= lim) return null;
            // По весам площадки: ищем первую позицию, где вес превысил предел.
            var lo = 0, hi = text.length;
            while (lo < hi) {
                var mid = (lo + hi) >> 1;
                if (sizeOf(text.slice(0, mid), 'chars', r) <= lim) lo = mid + 1; else hi = mid;
            }
            return Math.max(0, lo - 1);
        }
        if (u === 'sentences') {
            var ss = window.TSRank ? window.TSRank.split(text) : [];
            return ss.length > lim ? ss[lim - 1].end : null;
        }
        var re = /[\p{L}\p{N}][\p{L}\p{N}'’-]*/gu, m, n = 0;
        while ((m = re.exec(text))) {
            n++;
            if (n === lim) return re.lastIndex < text.length ? re.lastIndex : null;
        }
        return null;
    }

    // ── счёт и шкала ─────────────────────────────────────────────────────

    function updateMeter() {
        var src = sourceText();
        var showRes = !!S.plan && S.mode !== 'edit';
        var text = showRes ? resultText() : src;
        var u = countUnit();
        var size = sizeOf(text);
        var tgt = goalFor(src);
        var has = !!text.trim();

        var now = $('tsNow'), of = $('tsOf'), badge = $('tsBadge'), sub = $('tsSub');
        if (now) now.textContent = fmt(size);
        if (of) {
            var line = !has && S.goal.u === 'percent'
                ? '/ ' + fmt(S.goal.n) + ' %'
                : fill(t('of_line', '/ :n :u'), { n: fmt(tgt), u: plural(tgt, unitForms(u)) });
            if (has && S.goal.u === 'percent') line += ' (' + fmt(S.goal.n) + ' %)';
            if (rule() === 'sms' && window.TSPlan && has) {
                line += ' · ' + fill(t('sms_parts', ':n SMS'), { n: window.TSPlan.smsInfo(text).segments });
            }
            of.textContent = line;
        }
        var over = has && size > tgt;
        if (badge) {
            badge.className = 'ts-badge' + (has ? (over ? ' over' : ' ok') : '');
            badge.textContent = !has ? '' : (over ? fill(t('fit_over', '+:n'), { n: fmt(size - tgt) }) : '✓ ' + t('fit_ok'));
        }
        var card = $('tsCard');
        if (card) card.classList.toggle('over', over);
        if (sub) {
            // Одна строка текста: «короче на N %» — её начало, а не отдельный
            // элемент, который появлялся бы и толкал статистику.
            sub.textContent = '';
            // «Перетащите файл, Ctrl+Enter» — подсказка мыши и клавиатуры; на
            // телефоне строка остаётся пустой (её высота держится сама).
            if (!has) sub.appendChild(textNode(COARSE ? '' : t('hint_edit')));
            else {
                var pct = showRes && src.length ? Math.round((1 - text.length / src.length) * 100) : 0;
                if (pct > 0) {
                    var d = document.createElement('span');
                    d.className = 'ts-delta';
                    d.appendChild(textNode(fill(t('delta_line', '−:n %'), { n: pct })));
                    sub.appendChild(d);
                    sub.appendChild(textNode(' · '));
                }
                var w = window.TSTrim ? window.TSTrim.countWords(text, S.lang) : 0;
                var sN = window.TSRank ? window.TSRank.split(text).length : 0;
                sub.appendChild(textNode(fill(t('sub_line'), {
                    a: fmt(text.replace(/\s/g, '').length),
                    w: fmt(w) + ' ' + plural(w, t('u_words')),
                    s: fmt(sN) + ' ' + plural(sN, t('u_sent')),
                })));
            }
        }
        updateGauge(src, text, tgt);
    }

    /**
     * Шкала в единицах цели: максимум — длина исходника, бегунок — цель,
     * заливка — результат. Для процентов шкала 1–100.
     */
    function updateGauge(src, text, tgt) {
        var r = $('tsRange'), lbl = $('tsSrc');
        if (!r) return;
        var has = !!src.trim();
        r.disabled = !has;
        var u = S.goal.u;
        var full = has ? sizeOf(src) : 0;
        var res = has ? sizeOf(text) : 0;
        var max, val, a, b;
        if (u === 'percent') {
            max = 100; val = Math.min(100, S.goal.n);
            var pctRes = full ? res / full * 100 : 0;
            a = Math.min(pctRes, val) / 100; b = pctRes / 100;
        } else {
            max = Math.max(1, full); val = Math.min(max, S.goal.n);
            a = Math.min(res, tgt) / max; b = res / max;
        }
        r.min = '1';
        r.max = String(max);
        if (document.activeElement !== r) r.value = String(val);
        r.style.setProperty('--ts-a', String(Math.max(0, Math.min(1, has ? a : 0))));
        r.style.setProperty('--ts-b', String(Math.max(0, Math.min(1, has ? b : 0))));
        if (lbl) {
            // Подпись конца шкалы — длина исходника: без неё бегунок висит над
            // ничем. Для процентов — в знаках, в них проценты и считаются.
            lbl.textContent = has ? fill(t('src_line', ':n'), { n: fmt(u === 'percent' ? src.length : full) }) : '';
        }
    }

    // ── план ─────────────────────────────────────────────────────────────

    function opsOf() { return S.plan ? S.plan.ops.filter(function (o) { return o.cls !== 'sent'; }) : []; }

    function sentIndex(pos) {
        var ss = S.plan ? S.plan.sentences : [];
        var lo = 0, hi = ss.length - 1;
        while (lo <= hi) {
            var mid = (lo + hi) >> 1;
            if (pos < ss[mid].start) hi = mid - 1; else if (pos >= ss[mid].end) lo = mid + 1; else return mid;
        }
        return -1;
    }

    /** Текст по текущему состоянию переключателей — единственный источник выдачи. */
    function assemble() {
        if (!S.plan) return S.src;
        var live = [];
        Object.keys(S.drop).forEach(function (k) {
            if (!S.drop[k]) return;
            var sent = S.plan.sentences[k];
            if (sent) live.push({ s: sent.start, e: sent.end, rep: '', cap: false });
        });
        opsOf().forEach(function (o) {
            if (o.on === false) return;
            if (S.drop[sentIndex(o.s)]) return;
            live.push(o);
        });
        return window.TSTrim.apply(S.src, live);
    }

    function textKey(s) {
        var h = 5381;
        for (var i = 0; i < s.length; i++) h = ((h << 5) + h + s.charCodeAt(i)) | 0;
        return 'txt:' + (h >>> 0).toString(36) + ':' + s.length;
    }

    /**
     * Слот — на ТЕКСТ, а не на нажатие: пересчёт того же текста под другую
     * цель бесплатен (как повтор того же файла), новый текст — новый слот.
     * Списывается он при ВЫДАЧЕ (копия, файл), а не при разборе. Пересказ
     * нейросети оплачен токенами — его текст суточный счётчик не трогает.
     */
    function charge(src) {
        if (!window.__toolLimit) return Promise.resolve(true);
        var key = textKey(src);
        if (S.ticket && S.ticketKey === key) return Promise.resolve(true);
        if (S.ticket && !S.delivered) { try { S.ticket.abort(); } catch (e) {} }
        S.ticket = null; S.ticketKey = null; S.delivered = false;
        if (S.ai && S.ai.key === key) return Promise.resolve(true);
        return Promise.resolve(window.__toolLimit.begin(SLUG, key)).then(function (tk) {
            if (!tk) return false;
            S.ticket = tk; S.ticketKey = key; S.delivered = false;
            return true;
        }, function () { return true; });
    }

    function makePlan(src) {
        return window.TSPlan.make(src, {
            target: S.goal.u === 'percent' ? S.goal.n : goalFor(src),
            unit: S.goal.u, rule: rule(), lang: S.lang, off: S.off,
        });
    }

    function setPlan(plan) {
        S.plan = plan;
        S.drop = {}; S.mine = {}; S.open = {};
        plan.ops.forEach(function (o) { if (o.cls === 'sent') S.drop[sentIndex(o.s)] = true; });
        S.touched = false;
    }

    /** Ручная правка итога относится к прежнему сокращению — новое её отменяет. */
    function dropManual() {
        if (!S.manual) return;
        S.manual = false; S.manualText = '';
        note(t('manual_reset'));
    }

    /** Работа оказалась не нужна («уже влезает») — слот возвращается. */
    function refundIfIdle(plan) {
        if (plan.regime === 'fits' && S.ticket && !S.delivered) {
            try { S.ticket.abort(); } catch (e) {}
            S.ticket = null; S.ticketKey = null;
            return true;
        }
        return false;
    }

    function run(reason, toMode) {
        if (S.busy) return Promise.resolve();
        if (!window.TSPlan || !window.TSTrim || !window.TSRank) {
            toast(t('err_engine'), 'error');
            return Promise.resolve();
        }
        var src = sourceText();
        if (!src.trim()) {
            if (reason === 'user') toast(t('err_empty'), 'warning');
            return Promise.resolve();
        }
        S.lang = window.TSTrim.detectLang(src, PAGE_LANG);
        syncRuleTarget(src);
        S.busy = true;
        return charge(src).then(function (ok) {
            if (!ok) return;
            try {
                var fresh = S.src !== src || !S.plan;
                if (fresh) { S.manual = false; S.manualText = ''; } else dropManual();
                S.src = src;
                var plan = makePlan(src);
                setPlan(plan);
                refundIfIdle(plan);
                S.mode = toMode || S.view;
                paint(true);
                if (fresh) {
                    funnel('shortened', {
                        unit: S.goal.u, rule: rule() || '', preset: S.goal.p || '', target: plan.target,
                        src: plan.srcSize, out: plan.size, regime: plan.regime, lang: S.lang,
                        sentences: plan.sentences.length, shortfall: plan.shortfall, by: reason, ai: S.ai ? 1 : 0,
                    });
                    ae('shorten', { unit: S.goal.u, regime: plan.regime, ratio: plan.cutPct, by: reason, lang: S.lang });
                }
            } catch (e) {
                toast(t('err_generic'), 'error');
                if (window.__aeDiagnostic) {
                    window.__aeDiagnostic({ issue: 'shorten_failed', msg: String((e && e.message) || e).slice(0, 160) });
                }
            }
        }).then(function () { S.busy = false; }, function () { S.busy = false; });
    }

    /* Протяжка бегунка — пересчёт на кадре; набор числа — после паузы, иначе
       «280» успело бы побыть «2» и «28» и мигнуть пустым текстом. */
    var planTimer = 0, planRaf = 0;
    function schedulePlan(live) {
        clearTimeout(planTimer);
        if (live) {
            if (planRaf) return;
            planRaf = requestAnimationFrame(function () { planRaf = 0; replan(); });
            return;
        }
        planTimer = setTimeout(replan, 280);
    }
    /** Пересчёт того же исходника под новую цель — без нового слота. */
    function replan() {
        if (!S.plan || !window.TSPlan) return;
        // Исходник поправлен в «Тексте» — прежний план к нему не относится;
        // новый появится по «Сократить».
        if (stale()) { updateMeter(); paintOverflow(); return; }
        dropManual();
        var plan = makePlan(S.src);
        setPlan(plan);
        paint(false);
        if (refundIfIdle(plan)) return;
        /* Слот отдан назад, когда текст «уже влезал»; если новая цель требует
           работы, его надо взять снова — иначе «влезает → опустить бегунок →
           скопировать» обходил бы суточную норму. Нет слота — разбор убирается
           (стену показывает сам примитив). */
        if (plan.regime !== 'fits' && !S.ticket && !S.delivered) {
            var src = S.src;
            charge(src).then(function (ok) {
                if (ok || S.src !== src) return;
                S.plan = null;
                editMode();
                setEditorText(src);
                paint(false);
            });
        }
    }

    // ── показ ────────────────────────────────────────────────────────────

    /**
     * `animate` — ТОЛЬКО на смене вида. На пересчёте плана перехода нет:
     * startViewTransition откладывает колбэк на кадр, и в этот кадр счётчик
     * показывал бы прежний план (замер 2026-08-26: DOM 343, состояние 259).
     */
    function paint(animate) {
        if (!S.plan && S.mode !== 'edit') S.mode = 'edit';
        var apply = function () {
            renderCanvas();
            renderLadder();
            renderStatus();
            updateMeter();
            paintOverflow();
            reveal();
            renderMsg();
            syncAi();
        };
        if (animate && window.__viewTransition) { window.__viewTransition(apply); return; }
        apply();
    }

    function renderCanvas() {
        var cv = $('tsCanvas');
        if (cv) cv.setAttribute('data-mode', S.mode);
        if (S.mode === 'diff') { renderDiff(); return; }
        if (S.mode === 'clean') { renderClean(); return; }
        // «Текст» хранит живой исходник: перерисовка убила бы каретку, поэтому
        // текст ставится только при переходе из другого вида.
        var ed = $('tsEd');
        if (ed && ed.dataset.mode !== 'edit') { editMode(); setEditorText(S.src); }
    }

    /**
     * Места постоянного размера меняют только состояние: вкладки, подписи на
     * главной кнопке, доступность — ни одного `hidden` у того, что занимает место.
     */
    function reveal() {
        var hasSrc = !!sourceText().trim();
        var views = document.querySelectorAll('#tsViews [data-view]');
        views.forEach(function (b) {
            var v = b.getAttribute('data-view');
            var on = v === S.mode;
            var off = v !== 'edit' && !hasSrc;
            b.setAttribute('aria-checked', on ? 'true' : 'false');
            b.setAttribute('aria-disabled', off ? 'true' : 'false');
            b.tabIndex = on ? 0 : -1;
        });
        var main = $('tsRun');
        if (main) {
            var copied = Date.now() < S.copiedUntil;
            var label = S.mode === 'edit' ? 'go' : (copied ? 'done' : 'copy');
            main.querySelectorAll('[data-l]').forEach(function (sp) {
                var on = sp.getAttribute('data-l') === label;
                sp.classList.toggle('off', !on);
                sp.setAttribute('aria-hidden', on ? 'false' : 'true');
            });
            main.classList.toggle('done', label === 'done');
            main.disabled = !hasSrc;
            /* Пересказ оплачен токенами — суточная стена к его выдаче не
               относится, а примитив лимита красит кнопку серым, пока его
               заметка видна. Кнопка-то работает: краска снимается. */
            if (S.ai && S.mode !== 'edit' && main.classList.contains('tl-btn-blocked')) {
                main.classList.remove('tl-btn-blocked');
                main.removeAttribute('aria-disabled');
            }
        }
        var txt = $('tsTxt'); if (txt) txt.disabled = !S.plan || stale();
        var clr = $('tsClear'); if (clr) clr.disabled = !hasSrc && !S.plan;
        var empty = $('tsEmpty'); if (empty) empty.hidden = hasSrc || S.mode !== 'edit';
    }

    function textNode(s) { return document.createTextNode(s); }

    /**
     * Подряд выброшенные планом фразы сворачиваются в одну пометку, если их
     * больше одной или они длинные: при глубоком сокращении разбор иначе
     * превращался в стену зачёркнутого, в которой не найти оставленное.
     * Фразы, которые человек тронул сам, не сворачиваются никогда.
     */
    function collapsedRuns() {
        var runs = {}, ss = S.plan.sentences;
        for (var i = 0; i < ss.length; i++) {
            if (!S.drop[i] || S.mine[i]) continue;
            var j = i, chars = 0;
            while (j < ss.length && S.drop[j] && !S.mine[j]) { chars += ss[j].text.length; j++; }
            var n = j - i;
            if (n >= 2 || chars >= 240) runs[i] = { end: j - 1, n: n };
            i = j - 1;
        }
        return runs;
    }

    function gapNode(si, run, open) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'ts-gap no-tap-floor' + (open ? ' open' : '');
        b.dataset.gap = String(si);
        b.setAttribute('aria-expanded', open ? 'true' : 'false');
        b.textContent = open ? t('gap_hide')
            : fill(t('gap_show'), { n: fmt(run.n), u: plural(run.n, t('u_sent')) });
        return b;
    }

    function renderDiff() {
        var ed = $('tsEd');
        if (!ed || !S.plan) return;
        ed.setAttribute('contenteditable', 'false');
        ed.dataset.mode = 'diff';
        var keepScroll = ed.scrollTop;
        ed.textContent = '';

        var src = S.src, sents = S.plan.sentences, frag = document.createDocumentFragment();
        var byS = {};
        opsOf().forEach(function (o) {
            var i = sentIndex(o.s);
            if (i >= 0) (byS[i] = byS[i] || []).push(o);
        });
        var runs = collapsedRuns();

        var pos = 0;
        for (var si = 0; si < sents.length; si++) {
            var sent = sents[si];
            if (sent.start > pos) frag.appendChild(textNode(src.slice(pos, sent.start)));
            var run = runs[si];
            if (run) {
                var open = !!S.open[si];
                frag.appendChild(gapNode(si, run, open));
                if (!open) { pos = sents[run.end].end; si = run.end; continue; }
                frag.appendChild(textNode(' '));
            }
            frag.appendChild(sentenceNode(sent, si, byS[si] || [], src));
            pos = sent.end;
        }
        if (pos < src.length) frag.appendChild(textNode(src.slice(pos)));
        ed.appendChild(frag);
        ed.scrollTop = keepScroll;
    }

    function sentenceNode(sent, si, ops, src) {
        var box = document.createElement('span');
        box.className = 'ts-s no-tap-floor';
        box.dataset.s = String(si);
        box.setAttribute('role', 'button');
        box.tabIndex = 0;
        if (S.drop[si]) {
            box.classList.add('ts-op', 'ts-cut');
            box.setAttribute('aria-pressed', 'false');
            box.title = t('sent_keep');
            box.appendChild(textNode(sent.text));
        } else {
            box.setAttribute('aria-pressed', 'true');
            box.title = t('sent_drop');
            fillSentence(box, sent, ops, src);
        }
        return box;
    }

    function fillSentence(box, sent, ops, src) {
        var p = sent.start;
        ops.slice().sort(function (a, b) { return a.s - b.s; }).forEach(function (op) {
            var s0 = Math.max(op.s, sent.start), e0 = Math.min(op.e, sent.end);
            if (s0 < p || e0 <= s0) return;
            if (s0 > p) box.appendChild(textNode(src.slice(p, s0)));
            box.appendChild(opNode(op, src.slice(s0, e0)));
            p = e0;
        });
        if (p < sent.end) box.appendChild(textNode(src.slice(p, sent.end)));
    }

    function opNode(op, was) {
        var b = document.createElement('button');
        b.type = 'button';
        b.dataset.op = String(op._i);
        // Правка — это слово в строке, а не кнопка на панели: общий «пол» 44 px
        // для касаний раздувал бы межстрочие на телефоне.
        b.className = 'ts-op no-tap-floor';
        if (op.on === false) {
            b.setAttribute('aria-pressed', 'false');
            b.title = t('op_remove');
            b.appendChild(textNode(was));
            return b;
        }
        b.setAttribute('aria-pressed', 'true');
        b.title = t('op_restore');
        if (op.rep) {
            b.classList.add('ts-rep');
            var del = document.createElement('span');
            del.className = 'ts-was';
            del.appendChild(textNode(was));
            var ins = document.createElement('span');
            ins.className = 'ts-ins';
            ins.appendChild(textNode(op.rep));
            b.appendChild(del);
            b.appendChild(ins);
        } else {
            b.classList.add('ts-cut');
            b.appendChild(textNode(was));
        }
        return b;
    }

    /**
     * «Итог» — РЕДАКТИРУЕМЫЙ: на стыке двух оставленных фраз бывает шов,
     * который человек видит и должен иметь право поправить здесь же.
     */
    function renderClean() {
        var ed = $('tsEd');
        if (!ed) return;
        var text = S.manual ? S.manualText : assemble();
        ed.setAttribute('contenteditable', 'plaintext-only');
        ed.dataset.mode = 'clean';
        if (editorText() !== text) setEditorText(text);
    }

    function liveStats() {
        var st = {};
        CLASSES.forEach(function (c) { st[c] = { n: 0, save: 0 }; });
        if (!S.plan) return st;
        var cu = S.plan.unit;
        Object.keys(S.drop).forEach(function (k) {
            if (!S.drop[k]) return;
            var sent = S.plan.sentences[k];
            if (!sent) return;
            st.sent.n++;
            st.sent.save += cu === 'words' ? window.TSTrim.countWords(sent.text, S.lang)
                : (cu === 'sentences' ? 1 : sizeOf(sent.text, 'chars', S.plan.rule));
        });
        opsOf().forEach(function (o) {
            if (o.on === false || S.drop[sentIndex(o.s)]) return;
            st[o.cls].n++;
            st[o.cls].save += o.save || 0;
        });
        return st;
    }

    function renderLadder() {
        var st = liveStats(), has = !!S.plan;
        var head = $('tsSideT');
        if (head) head.textContent = has ? t('side_after') : t('side_before');
        document.querySelectorAll('.ts-step').forEach(function (row) {
            var c = row.getAttribute('data-cls');
            var sw = row.querySelector('.ts-sw');
            var cnt = row.querySelector('[data-c]');
            var off = !!S.off[c];
            if (sw) sw.checked = !off;
            var used = has && st[c] && st[c].n > 0 && !off;
            row.classList.toggle('off', off);
            row.classList.toggle('used', used);
            row.classList.toggle('idle', !used && !off);
            if (cnt) cnt.textContent = used ? '−' + fmt(st[c].save) : (has && !off ? '0' : '');
        });
        var lang = $('tsLang');
        if (lang) {
            var name = (CFG.langs || {})[S.lang];
            lang.textContent = name && sourceText().trim() ? fill(t('lang_label', ':lang'), { lang: name }) : '';
        }
    }

    function renderStatus() {
        var el = $('tsStatus');
        if (!el) return;
        if (!S.plan) { el.textContent = t('side_intro'); return; }
        var p = S.plan;
        var dropped = Object.keys(S.drop).filter(function (k) { return S.drop[k]; }).length;
        var key = p.regime === 'fits' ? 'st_fits'
            : (p.unit === 'sentences' ? 'st_sentences' : (p.regime === 'words' ? 'st_words' : 'st_sent'));
        el.textContent = fill(t(key), {
            n: fmt(dropped), total: fmt(p.sentences.length), k: fmt(p.sentences.length - dropped),
        });
    }

    // ── одно место для одного сообщения ──────────────────────────────────

    var noteTimer = 0;
    function note(text) {
        S.note = { text: text, until: Date.now() + 7000 };
        clearTimeout(noteTimer);
        noteTimer = setTimeout(function () { S.note = null; renderMsg(); }, 7100);
    }

    /**
     * Что сказать сейчас — ровно одно, по старшинству: отказ пересказа →
     * разовая заметка → «это пересказ» → «короче не выйдет» → правило площадки
     * → глубокое сокращение → язык без пословных правил → подсказка вида.
     */
    function pickMsg() {
        if (S.aiMsg) return S.aiMsg;
        if (S.note && Date.now() < S.note.until) return { text: S.note.text };
        if (S.ai) {
            return {
                text: fill(t('ai_done'), { n: fmt(S.ai.cost || 0), b: fmt(S.ai.balance || 0) }),
                action: { label: t('ai_restore'), fn: aiRestore },
            };
        }
        var has = !!sourceText().trim();
        var p = S.plan;
        if (p && !stale() && sizeOf(resultText()) > goalFor(S.src)) return { text: t('note_shortfall'), warn: true };
        var r = rule();
        if (r === 'x') return { text: t('rule_x') };
        if (r === 'sms' && window.TSPlan) {
            return { text: window.TSPlan.smsInfo(sourceText() || defaultSmsProbe()).gsm ? t('rule_sms_gsm') : t('rule_sms_ucs') };
        }
        if (p && !stale() && p.regime === 'sentences' && p.unit !== 'sentences' && p.cutPct >= 55) {
            return { text: t('note_deep') };
        }
        if (p && p.regime !== 'fits' && window.TSTrim && !window.TSTrim.hasRules(S.lang)) return { text: t('note_lang') };
        if (!has) return { text: t('hint_start') };
        if (S.mode === 'diff') return { text: t('toggle_hint') };
        if (S.mode === 'clean') return { text: t('hint_clean') };
        return { text: p ? t('hint_text') : t('hint_ready') };
    }

    function renderMsg() {
        var el = $('tsMsg');
        if (!el) return;
        var m = pickMsg();
        el.className = 'ts-msg' + (m.warn ? ' warn' : '');
        el.textContent = '';
        el.appendChild(textNode(m.text || ''));
        if (m.link && m.link.href) {
            el.appendChild(textNode(' '));
            var a = document.createElement('a');
            a.href = m.link.href;
            a.textContent = m.link.label;
            Object.keys(m.link.attrs || {}).forEach(function (k) { a.setAttribute(k, m.link.attrs[k]); });
            el.appendChild(a);
        }
        if (m.action) {
            el.appendChild(textNode(' '));
            var b = document.createElement('button');
            b.type = 'button';
            b.className = 'link no-tap-floor';
            b.textContent = m.action.label;
            b.addEventListener('click', m.action.fn);
            el.appendChild(b);
        }
    }

    // ── взаимодействие с разбором ────────────────────────────────────────

    function flash(el) {
        if (!el) return;
        el.classList.remove('ts-flash'); void el.offsetWidth; el.classList.add('ts-flash');
    }

    function onCanvasActivate(e) {
        if (S.mode !== 'diff') return;
        // Протяжка — это выделение, а не нажатие; но засчитывается ТОЛЬКО
        // выделение внутри холста: подсвеченное число в поле цели иначе съедало
        // первое нажатие по тексту (разбор 2026-08-26).
        var ed = $('tsEd');
        var sel = window.getSelection && window.getSelection();
        if (e.type === 'click' && sel && !sel.isCollapsed && ed && sel.anchorNode && ed.contains(sel.anchorNode)) return;

        var gap = e.target.closest && e.target.closest('[data-gap]');
        if (gap) {
            e.preventDefault();
            var gi = gap.dataset.gap;
            S.open[gi] = !S.open[gi];
            ae('gap', { open: S.open[gi] ? 1 : 0 });
            renderDiff();
            var again = document.querySelector('[data-gap="' + gi + '"]');
            if (again) { try { again.focus({ preventScroll: true }); } catch (x) {} }
            return;
        }
        var opEl = e.target.closest && e.target.closest('[data-op]');
        if (opEl) {
            e.preventDefault();
            e.stopPropagation();
            var op = opsOf().filter(function (o) { return String(o._i) === opEl.dataset.op; })[0];
            if (op) {
                dropManual();
                op.on = op.on === false;
                mark('toggle_op', { cls: op.cls });
                paint(false);
                flash(document.querySelector('[data-op="' + op._i + '"]'));
            }
            return;
        }
        var sEl = e.target.closest && e.target.closest('[data-s]');
        if (sEl) {
            e.preventDefault();
            var i = sEl.dataset.s;
            dropManual();
            S.drop[i] = !S.drop[i];
            S.mine[i] = true;
            mark('toggle_sentence', {});
            paint(false);
            flash(document.querySelector('[data-s="' + i + '"]'));
        }
    }

    function mark(what, p) {
        if (!S.touched) { S.touched = true; ae(what, p || {}); }
    }

    function onLadderChange(e) {
        var sw = e.target.closest && e.target.closest('.ts-sw');
        if (!sw) return;
        var cls = sw.getAttribute('data-cls');
        if (sw.checked) delete S.off[cls]; else S.off[cls] = true;
        save('off', S.off);
        ae('toggle_class', { cls: cls, off: S.off[cls] ? 1 : 0 });
        // Запрещённая ступень не просто исчезает: недостающие знаки план ищет на
        // других, поэтому пересчёт — целиком.
        if (S.plan) replan(); else renderLadder();
    }

    // ── выдача ───────────────────────────────────────────────────────────

    function commit(how) {
        if (S.ticket) { try { S.ticket.commit(); } catch (e) {} }
        S.delivered = true;
        ae('deliver', { how: how, touched: S.touched ? 1 : 0, ai: S.ai ? 1 : 0, manual: S.manual ? 1 : 0, unit: S.goal.u });
        if (window.__aeToolComplete) window.__aeToolComplete({ how: how, unit: S.goal.u, ai: S.ai ? 1 : 0 });
    }

    function writeClipboard(text) {
        if (navigator.clipboard && navigator.clipboard.writeText) return navigator.clipboard.writeText(text);
        return new Promise(function (resolve, reject) {
            var ta = document.createElement('textarea');
            ta.value = text; ta.setAttribute('readonly', '');
            ta.style.position = 'fixed'; ta.style.opacity = '0';
            document.body.appendChild(ta); ta.select();
            var ok = false;
            try { ok = document.execCommand('copy'); } catch (e) {}
            document.body.removeChild(ta);
            if (ok) resolve(); else reject(new Error('copy'));
        });
    }

    var copyTimer = 0;
    function copyOut() {
        var text = resultText();
        if (!text) return;
        writeClipboard(text).then(function () {
            S.copiedUntil = Date.now() + 1800;
            reveal();
            clearTimeout(copyTimer);
            copyTimer = setTimeout(reveal, 1850);
            if (window.__announce) window.__announce(t('copied'));
            commit('copy');
        }, function () { toast(t('err_copy'), 'warning'); });
    }

    function downloadOut() {
        var text = resultText();
        if (!text) return;
        var blob = new Blob([text], { type: 'text/plain;charset=utf-8' });
        var stem = 'text-' + (S.goal.p || (S.goal.n + ({ chars: 'c', words: 'w', sentences: 's', percent: 'pc' })[S.goal.u]));
        var name = window.__outputName ? window.__outputName.join([stem], 'txt') : stem + '.txt';
        Promise.resolve(window.__downloadFile ? window.__downloadFile(blob, name) : false).then(function (ok) {
            if (ok !== false) commit('download');
        });
    }

    function onMain() {
        if (S.mode !== 'edit') { copyOut(); return; }
        // Исходник не менялся — правка уже готова, нового разбора не нужно.
        if (S.plan && !stale()) { S.mode = S.view; paint(true); return; }
        run('user');
    }

    // ── лимиты площадок ──────────────────────────────────────────────────

    /** Подпись числа — та же, что сервер поставил в фишку; SMS — по алфавиту текста. */
    function presetLabel(p) {
        if (p.r === 'sms') return String(window.TSPlan ? window.TSPlan.smsInfo(sourceText() || defaultSmsProbe()).limit : p.n);
        return p.num != null ? String(p.num) : '';
    }

    function presetByKey(k) {
        return (CFG.presets || []).filter(function (p) { return p.k === k; })[0] || null;
    }

    function buildMoreList() {
        var box = $('tsMoreList');
        if (!box) return;
        box.textContent = '';
        Object.keys(CFG.groups || {}).forEach(function (g) {
            var items = (CFG.presets || []).filter(function (p) { return p.g === g; });
            if (!items.length) return;
            var sec = document.createElement('div');
            sec.className = 'ts-more-g';
            var h = document.createElement('h4');
            h.appendChild(textNode(CFG.groups[g]));
            sec.appendChild(h);
            items.forEach(function (p) {
                var row = document.createElement('div');
                row.className = 'ts-pv';
                row.setAttribute('data-k', p.k);
                var b = document.createElement('button');
                b.type = 'button';
                b.className = 'ts-pv-b';
                b.setAttribute('data-preset', p.k);
                var l = document.createElement('span'); l.className = 'ts-pv-l'; l.appendChild(textNode(p.label));
                var n = document.createElement('span'); n.className = 'ts-pv-n'; n.appendChild(textNode(presetLabel(p) || ''));
                var r = document.createElement('span'); r.className = 'ts-pv-r'; r.setAttribute('data-r', '');
                b.appendChild(l); b.appendChild(n); b.appendChild(r);
                var c = document.createElement('button');
                c.type = 'button';
                c.className = 'ts-pv-c';
                c.hidden = true;
                c.setAttribute('data-copy', p.k);
                c.title = t('copy_version');
                c.setAttribute('aria-label', t('copy_version') + ': ' + p.label);
                c.innerHTML = '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="9" y="9" width="12" height="12" rx="2"/><path d="M5 15V5a2 2 0 012-2h10"/></svg>';
                row.appendChild(b);
                row.appendChild(c);
                sec.appendChild(row);
            });
            box.appendChild(sec);
        });
    }

    function planForPreset(p, src) {
        var n = p.r === 'sms' ? window.TSPlan.smsInfo(src).limit : p.n;
        return window.TSPlan.make(src, { target: n, unit: p.u, rule: p.u === 'chars' ? (p.r || null) : null, lang: S.lang, off: S.off });
    }

    /**
     * Каталог считает, во что превратится ВАШ текст под каждый лимит: «✓» —
     * влезает как есть, «−18 %» — хватит лишних слов, янтарное «−62 %» —
     * уйдут предложения. Считается при открытии, кусками между кадрами:
     * разбор текста кэширован, и 25 планов на главе — это десятки мс.
     */
    var moreJob = 0;
    function refreshMore() {
        var src = S.plan ? S.src : editorText();
        var job = ++moreJob;
        var rows = Array.prototype.slice.call(document.querySelectorAll('.ts-pv'));
        rows.forEach(function (row) {
            var p = presetByKey(row.getAttribute('data-k'));
            var n = row.querySelector('.ts-pv-n');
            if (p && n) n.textContent = presetLabel(p) || '';
        });
        var noteEl = $('tsMoreNote');
        if (noteEl) noteEl.hidden = !src.trim();
        if (!src.trim() || !window.TSPlan) {
            rows.forEach(function (row) {
                var r = row.querySelector('[data-r]'); if (r) { r.textContent = ''; r.className = 'ts-pv-r'; }
                var c = row.querySelector('[data-copy]'); if (c) c.hidden = true;
            });
            return;
        }
        S.lang = window.TSTrim.detectLang(src, PAGE_LANG);
        var i = 0;
        (function step() {
            if (job !== moreJob) return;
            var t0 = performance.now();
            while (i < rows.length && performance.now() - t0 < 12) {
                var row = rows[i++];
                var p = presetByKey(row.getAttribute('data-k'));
                var r = row.querySelector('[data-r]'), c = row.querySelector('[data-copy]');
                if (!p || !r) continue;
                var pl;
                try { pl = planForPreset(p, src); } catch (e) { continue; }
                row.__plan = pl;
                row.__src = src;
                if (pl.regime === 'fits') { r.textContent = '✓'; r.className = 'ts-pv-r fits'; r.title = t('pv_fits'); }
                else {
                    r.textContent = '−' + Math.max(1, pl.cutPct) + ' %';
                    r.className = 'ts-pv-r ' + (pl.regime === 'words' ? 'words' : 'sent');
                    r.title = pl.regime === 'words' ? t('pv_words') : t('pv_sent');
                }
                if (c) c.hidden = false;
            }
            if (i < rows.length) requestAnimationFrame(step);
        })();
    }

    function applyPreset(k) {
        var p = presetByKey(k);
        if (!p) return;
        ae('preset', { k: k, n: p.n, u: p.u });
        var more = $('tsMore');
        if (more && more.hidePopover && more.matches(':popover-open')) { try { more.hidePopover(); } catch (e) {} }
        var n = p.r === 'sms' && window.TSPlan ? window.TSPlan.smsInfo(sourceText() || defaultSmsProbe()).limit : p.n;
        // Правило счёта площадки называется в момент выбора: «почему 70, а не
        // 160» спрашивают именно тогда, а не после разбора.
        if (p.r === 'x') note(t('rule_x'));
        else if (p.r === 'sms' && window.TSPlan) {
            note(window.TSPlan.smsInfo(sourceText() || defaultSmsProbe()).gsm ? t('rule_sms_gsm') : t('rule_sms_ucs'));
        }
        setGoal(n, p.u, p.r || null, p.k, 'preset');
        if (!S.plan && sourceText().trim()) run('preset');
    }

    /**
     * Версия под площадку — такая же выдача, как «Скопировать»: тот же слот на
     * текст. Если слот уже взят, буфер пишется сразу, в том же нажатии (Safari
     * отдаёт буфер только жесту); если нет — сначала слот, потом буфер.
     */
    function copyVersion(k) {
        var row = document.querySelector('.ts-pv[data-k="' + k + '"]');
        var pl = row && row.__plan;
        if (!pl) return;
        var src = row.__src || sourceText();
        var write = function () {
            return writeClipboard(pl.text).then(function () {
                toast(t('copied') + ' · ' + (presetByKey(k) || {}).label, 'success');
                ae('version_copy', { k: k, regime: pl.regime });
                if (pl.regime !== 'fits') commit('version');
            }, function () { toast(t('err_copy'), 'warning'); });
        };
        if (pl.regime === 'fits' || (S.ticket && S.ticketKey === textKey(src)) || (S.ai && S.ai.key === textKey(src))) { write(); return; }
        charge(src).then(function (ok) { if (ok) write(); });
    }

    // ── ввод: вставка, пример, файл, фото ────────────────────────────────

    /** Новый текст на холсте. `keepAi` — это ответ пересказа, а не текст автора. */
    function afterNewText(reason, keepAi) {
        editMode();
        S.plan = null; S.drop = {}; S.mine = {}; S.open = {};
        S.manual = false; S.manualText = '';
        S.aiMsg = null;
        if (!keepAi) S.ai = null;
        var text = editorText();
        S.lang = window.TSTrim ? window.TSTrim.detectLang(text, PAGE_LANG) : PAGE_LANG;
        if (syncRuleTarget(text)) { save('goal', S.goal); }
        syncGoalUi();
        funnel('pasted', { chars: text.length, by: reason });
        paint(false);
        refreshChips();
        if (text.trim()) return run(reason);
    }

    /** Подпись SMS-фишки зависит от алфавита текста. */
    function refreshChips() {
        document.querySelectorAll('.ts-chip[data-preset]').forEach(function (b) {
            var p = presetByKey(b.getAttribute('data-preset'));
            if (!p || p.r !== 'sms') return;
            var strong = b.querySelector('b');
            var lab = presetLabel(p);
            if (strong && strong.textContent !== lab) strong.textContent = lab;
        });
    }

    function pasteFromClipboard() {
        var ed = $('tsEd');
        var fallback = function () {
            if (ed) { try { ed.focus({ preventScroll: true }); } catch (e) { ed.focus(); } }
            toast(t('paste_hint'), 'info');
        };
        if (!navigator.clipboard || !navigator.clipboard.readText) { fallback(); return; }
        navigator.clipboard.readText().then(function (txt) {
            if (!txt || !txt.trim()) { fallback(); return; }
            setEditorText(txt.replace(/\r\n?/g, '\n'));
            ae('paste_button', { chars: txt.length });
            afterNewText('paste');
        }, fallback);
    }

    /* Строки, оборванные переносом (PDF, фото страницы), склеиваются обратно:
       иначе каждая строка становилась бы отдельным «предложением». Перенос
       слова «доку-\nмент» снимается. */
    function unwrap(text) {
        return String(text || '').replace(/\r\n?/g, '\n')
            .replace(/(\p{L})[-\u00AD]\n(\p{Ll})/gu, '$1$2')
            .replace(/([^\n.!?…:;])\n(?=\p{Ll})/gu, '$1 ')
            .replace(/[ \t]+\n/g, '\n')
            .replace(/\n{3,}/g, '\n\n')
            .trim();
    }

    /* .txt из Windows часто в cp1251: строгий UTF-8 на нём падает, и тогда —
       кириллическая однобайтовая. Без этого русский файл открывался «кракозябрами». */
    function decodeText(buf) {
        try { return new TextDecoder('utf-8', { fatal: true }).decode(buf); }
        catch (e) {
            try { return new TextDecoder('windows-1251').decode(buf); }
            catch (e2) { return new TextDecoder('utf-8').decode(buf); }
        }
    }

    function loadScriptChain(urls, test) {
        return new Promise(function (resolve, reject) {
            if (test()) { resolve(); return; }
            var i = 0;
            (function next() {
                if (i >= urls.length) { reject(new Error('load')); return; }
                var s = document.createElement('script');
                s.src = urls[i++];
                s.onload = function () { if (test()) resolve(); else next(); };
                s.onerror = next;
                document.head.appendChild(s);
            })();
        });
    }

    function readPdf(file) {
        // Через дверь layout: она дожидается отдельного скрипта загрузчика сама.
        if (!window.__pdfjs) return Promise.reject(new Error('pdfjs'));
        return Promise.all([window.__pdfjs(CFG.pdfjs || []), file.arrayBuffer()]).then(function (r) {
            return r[0].getDocument({ data: new Uint8Array(r[1]), isEvalSupported: false }).promise;
        }).then(function (pdf) {
            var pages = [], n = Math.min(pdf.numPages, 80);
            var chain = Promise.resolve();
            for (var i = 1; i <= n; i++) {
                (function (pi) {
                    chain = chain.then(function () { return pdf.getPage(pi); }).then(function (pg) {
                        return pg.getTextContent();
                    }).then(function (tc) {
                        var out = '';
                        tc.items.forEach(function (it) { out += (it.str || '') + (it.hasEOL ? '\n' : ''); });
                        pages.push(out);
                    });
                })(i);
            }
            return chain.then(function () { return unwrap(pages.join('\n\n')); });
        });
    }

    function readDocx(file) {
        return loadScriptChain(CFG.mammoth || [], function () { return !!window.mammoth; }).then(function () {
            return file.arrayBuffer();
        }).then(function (buf) {
            return window.mammoth.extractRawText({ arrayBuffer: buf });
        }).then(function (res) {
            return String((res && res.value) || '').replace(/\n{3,}/g, '\n\n').trim();
        });
    }

    var ocrP = null, ocrEngine = null;
    function ocrOpen(onState) {
        if (ocrEngine) return Promise.resolve(ocrEngine);
        if (ocrP) return ocrP;
        var O = CFG.ocr || {};
        if (O.worker) window.__PPOCR_WORKER_URL = O.worker;
        ocrP = loadScriptChain([O.ppocr], function () { return !!window.PPOCR; }).catch(function () {})
            .then(function () { return loadScriptChain([O.engine], function () { return !!window.OcrEngine; }); })
            .then(function () {
                return Promise.resolve(window.OcrEngine.downloadMb ? window.OcrEngine.downloadMb(O.langs) : 0)
                    .then(function (mb) {
                        if (mb > 0) onState(fill(t('import_ocr_dl'), { mb: Math.max(1, Math.round(mb)) }));
                    }, function () {});
            })
            .then(function () {
                return window.OcrEngine.open(O.langs, {
                    slug: SLUG, tesseractUrl: O.tesseractUrl, tesseract: O.tesseract || {},
                    onProgress: function (p) { if (p > 0 && p < 1) onState(t('import_ocr') + ' ' + Math.round(p * 100) + '%'); },
                });
            })
            .then(function (eng) { ocrEngine = eng; ocrP = null; return eng; }, function (e) { ocrP = null; throw e; });
        return ocrP;
    }

    function readImage(file, onState) {
        onState(t('import_ocr'));
        return ocrOpen(onState).then(function (eng) {
            return eng.recognize(file, { orient: true });
        }).then(function (data) { return unwrap(data && data.text); });
    }

    function importFile(file) {
        if (!file) return;
        var name = String(file.name || '');
        var ext = (name.split('.').pop() || '').toLowerCase();
        var type = String(file.type || '');
        var kind = /^image\//.test(type) || /^(jpe?g|png|webp|heic|heif|bmp|gif|avif|tiff?)$/.test(ext) ? 'image'
            : (ext === 'pdf' || type === 'application/pdf') ? 'pdf'
            : (ext === 'docx' || /wordprocessingml/.test(type)) ? 'docx'
            : (/^(txt|md|text|csv)$/.test(ext) || /^text\//.test(type)) ? 'text' : null;
        if (!kind) { toast(t('import_type'), 'warning'); ae('import_refused', { ext: ext }); return; }

        var status = $('tsStatus');
        var onState = function (msg) { if (status) status.textContent = msg; };
        onState(fill(t('import_reading'), { name: name }));
        var t0 = Date.now();
        var job = kind === 'image' ? readImage(file, onState)
            : kind === 'pdf' ? readPdf(file)
            : kind === 'docx' ? readDocx(file)
            : file.arrayBuffer().then(decodeText);
        job.then(function (text) {
            text = String(text || '').replace(/\r\n?/g, '\n').trim();
            if (!text) {
                toast(t('import_empty'), 'warning');
                ae('import_empty', { kind: kind });
                renderStatus();
                return;
            }
            setEditorText(text);
            ae('import', { kind: kind, chars: text.length, s: Math.round((Date.now() - t0) / 1000) });
            toast(fill(t('import_done'), { name: name }), 'success');
            afterNewText('import_' + kind);
        }).catch(function (e) {
            toast(t('import_failed'), 'error');
            renderStatus();
            if (window.__aeDiagnostic) window.__aeDiagnostic({ issue: 'import_failed', kind: kind, msg: String((e && e.message) || e).slice(0, 120) });
        });
    }

    function bindUploader() {
        var zone = $('tsFile');
        if (!zone) return;
        if (typeof window.__bindUploaderFile === 'function') window.__bindUploaderFile(zone, importFile);
        else zone.addEventListener('tool-uploader:file', function (e) { var f = e.detail && e.detail.file; if (f) importFile(f); });
        zone.addEventListener('tool-uploader:clear', function () { ae('import_clear', {}); });

        var open = $('tsOpen');
        if (open) open.addEventListener('click', function () {
            var input = zone.querySelector('input[type=file]');
            if (input) input.click(); else zone.click();
        });

        // Файл, брошенный прямо на текст, идёт той же дверью, что и выбранный.
        var cv = $('tsCanvas');
        if (!cv) return;
        var hasFiles = function (e) {
            var dt = e.dataTransfer;
            return !!(dt && dt.types && Array.prototype.indexOf.call(dt.types, 'Files') >= 0);
        };
        cv.addEventListener('dragover', function (e) { if (!hasFiles(e)) return; e.preventDefault(); cv.classList.add('drop'); });
        cv.addEventListener('dragleave', function () { cv.classList.remove('drop'); });
        cv.addEventListener('drop', function (e) {
            cv.classList.remove('drop');
            if (!hasFiles(e)) return;
            e.preventDefault();
            var f = e.dataTransfer.files && e.dataTransfer.files[0];
            if (!f) return;
            if (typeof zone.__uploaderInjectFile === 'function') zone.__uploaderInjectFile(f, 'drop');
            else importFile(f);
        });
    }

    // ── шестая ступень: пересказ нейросетью ──────────────────────────────

    /** Пересказывается всегда текст АВТОРА — повторный пересказ не идёт по пересказу. */
    function aiSource() {
        if (S.ai) return S.ai.prev;
        return S.plan && !stale() ? S.src : sourceText();
    }
    function aiTokens(chars) {
        return Math.max(AI.minTok || 30, Math.ceil(chars / 1000 * (AI.per1000 || 150)));
    }
    function aiCostLabel(chars) {
        var tok = aiTokens(chars);
        if (AI.rubPerTok) {
            var rub = tok * AI.rubPerTok, d = rub < 1 ? 2 : 1;
            var s;
            try { s = rub.toLocaleString(LOC, { minimumFractionDigits: d, maximumFractionDigits: d }); }
            catch (e) { s = rub.toFixed(d); }
            return fill(t('ai_cost_rub'), { rub: s });
        }
        return fill(t('ai_cost_tok'), { n: fmt(tok) });
    }

    function syncAi() {
        var b = $('tsAi'), sub = $('tsAiSub');
        if (!b || !sub) return;
        b.classList.toggle('busy', S.aiBusy);
        b.setAttribute('aria-busy', S.aiBusy ? 'true' : 'false');
        if (!AI.enabled) { b.disabled = true; sub.textContent = t('ai_off'); return; }
        if (S.aiBusy) { b.disabled = true; sub.textContent = t('ai_busy'); return; }
        var src = aiSource();
        var has = src.trim().length >= (AI.minChars || 10);
        b.disabled = !has;
        sub.textContent = has ? fill(t('ai_sub'), { cost: aiCostLabel(src.trim().length) }) : t('ai_sub_empty');
    }

    function aiFail(status, d) {
        var m;
        if (status === 401) {
            m = { text: t('ai_need_login'), link: { href: AI.loginUrl, label: t('ai_login') } };
        } else if (status === 402) {
            var need = fmt(d.need || 0), bal = fmt(d.balance || 0);
            m = AI.buyUrl
                ? { text: fill(t('ai_need_tokens'), { need: need, bal: bal }),
                    link: { href: AI.buyUrl, label: t('ai_topup'), attrs: { 'data-tmb-short': String(Math.max(0, (d.need || 0) - (d.balance || 0))) } } }
                : { text: fill(t('ai_need_tokens'), { need: need, bal: bal }) };
        } else if (status === 422 && d && d.msg) {
            m = { text: String(d.msg), warn: true };
        } else if (status === 429) {
            m = { text: t('ai_throttled'), warn: true };
        } else if (status === 503) {
            m = { text: t('ai_off'), warn: true };
        } else {
            m = { text: t('ai_failed'), warn: true };
        }
        S.aiMsg = m;
        ae('ai_fail', { status: status || 0 });
        renderMsg();
    }

    /* Страница отдаётся из общего кэша: кто вошёл и свежий CSRF-токен
       приезжают отдельным запросом сессии, который кончается событием
       `tier-bootstrap:ready` (и меткой `server_now` в снимке тарифа). До него
       `__AUTH_USER` — ещё не ответ, а токен в <meta> может быть чужим (419). */
    var booted = false;
    document.addEventListener('tier-bootstrap:ready', function () { booted = true; });
    function sessionKnown() {
        return booted || !!(window.__tierLimits && window.__tierLimits.server_now);
    }
    function whenSession(ms) {
        if (sessionKnown()) return Promise.resolve(true);
        return new Promise(function (resolve) {
            var done = false;
            var fin = function (v) { if (!done) { done = true; resolve(v); } };
            document.addEventListener('tier-bootstrap:ready', function () { fin(true); }, { once: true });
            setTimeout(function () { fin(sessionKnown()); }, ms);
        });
    }

    function aiRun() {
        if (S.aiBusy || !AI.enabled) return;
        var src = aiSource().trim();
        if (!src) return;
        S.aiMsg = null;
        if (src.length > (AI.maxChars || 20000)) {
            S.aiMsg = { text: fill(t('ai_too_long'), { max: fmt(AI.maxChars || 20000) }), warn: true };
            renderMsg();
            return;
        }
        var u = countUnit(), n = goalFor(src);
        if (sizeOf(src) <= n) {
            S.aiMsg = { text: t('ai_too_short') };
            renderMsg();
            return;
        }
        S.aiBusy = true;
        syncAi();
        renderMsg();
        var cv = $('tsCanvas'); if (cv) cv.classList.add('busy');
        lockEditor(true);
        var t0 = Date.now();
        ae('ai_run', { unit: u, n: n, chars: src.length, lang: S.lang });
        whenSession(4000).then(function (known) {
            // Гость, о котором сессия уже сказала, — «войдите» без запроса;
            // сессия не ответила — решает сервер (401).
            if (known && !window.__AUTH_USER) {
                S.aiBusy = false;
                if (cv) cv.classList.remove('busy');
                lockEditor(false);
                aiFail(401, {});
                syncAi();
                return;
            }
            aiSend(src, u, n, cv, t0);
        });
    }

    /* Пока модель пересказывает, текст на холсте не правится: ответ заменит
       его целиком, и набранное за эти секунды пропало бы молча. */
    function lockEditor(on) {
        var ed = $('tsEd');
        if (!ed || S.mode === 'diff') return;
        ed.setAttribute('contenteditable', on ? 'false' : 'plaintext-only');
    }

    function aiSend(src, u, n, cv, t0) {
        var csrf = (document.querySelector('meta[name="csrf-token"]') || {}).content || '';
        fetch(AI.url, {
            method: 'POST', credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-CSRF-TOKEN': csrf, 'X-Requested-With': 'XMLHttpRequest' },
            body: JSON.stringify({ text: src, action: 'fit', target_n: n, target_unit: u, lang: S.lang, from: SLUG }),
        }).then(function (r) {
            return r.json().catch(function () { return {}; }).then(function (d) { return { status: r.status, d: d || {} }; });
        }).then(function (res) {
            S.aiBusy = false;
            if (cv) cv.classList.remove('busy');
            lockEditor(false);
            if (res.status === 200 && res.d.ok && String(res.d.text || '').trim()) {
                var out = String(res.d.text).replace(/\r\n?/g, '\n').trim();
                S.ai = { prev: src, key: textKey(out), cost: res.d.cost_tokens, balance: res.d.balance };
                ae('ai_done', { chars: src.length, out: out.length, s: Math.round((Date.now() - t0) / 1000), cost: res.d.cost_tokens || 0 });
                setEditorText(out);
                // Модель знаков не считает — точное число добирает движок.
                afterNewText('ai', true);
                return;
            }
            aiFail(res.status, res.d);
            syncAi();
        }, function () {
            S.aiBusy = false;
            if (cv) cv.classList.remove('busy');
            lockEditor(false);
            aiFail(0, {});
            syncAi();
        });
    }

    function aiRestore() {
        if (!S.ai) return;
        var prev = S.ai.prev;
        S.ai = null;
        setEditorText(prev);
        ae('ai_restore', {});
        afterNewText('ai_restore');
    }

    // ── сброс ────────────────────────────────────────────────────────────

    function clearAll() {
        if (S.ticket && !S.delivered) { try { S.ticket.abort(); } catch (e) {} }
        S.ticket = null; S.ticketKey = null; S.delivered = false;
        S.src = '';
        setEditorText('');
        editMode();
        S.plan = null; S.drop = {}; S.mine = {}; S.open = {};
        S.manual = false; S.manualText = '';
        S.ai = null; S.aiMsg = null; S.note = null;
        ae('clear', {});
        syncGoalUi();
        paint(false);
        refreshChips();
        var ed = $('tsEd');
        if (ed) { try { ed.focus({ preventScroll: true }); } catch (e) {} }
    }

    // ── связывание ───────────────────────────────────────────────────────

    function bindSeg(groupId, attr, onPick) {
        var g = $(groupId);
        if (!g) return;
        g.addEventListener('click', function (e) {
            var b = e.target.closest && e.target.closest('[' + attr + ']');
            if (b && b.getAttribute('aria-disabled') !== 'true') onPick(b.getAttribute(attr));
        });
        // Радиогруппа по стрелкам, как у родного <input type=radio>.
        g.addEventListener('keydown', function (e) {
            if (['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown'].indexOf(e.key) < 0) return;
            var items = Array.prototype.slice.call(g.querySelectorAll('[' + attr + ']'))
                .filter(function (x) { return x.getAttribute('aria-disabled') !== 'true'; });
            var i = items.indexOf(document.activeElement);
            if (i < 0) return;
            e.preventDefault();
            var rtl = document.documentElement.dir === 'rtl';
            var fwd = e.key === 'ArrowDown' || (e.key === (rtl ? 'ArrowLeft' : 'ArrowRight'));
            var nx = items[(i + (fwd ? 1 : items.length - 1)) % items.length];
            nx.focus();
            onPick(nx.getAttribute(attr));
        });
    }

    function pickView(v) {
        if (v === S.mode) return;
        ae('view', { v: v });
        if (v === 'edit') {
            // Исходник — на холст; план остаётся, и «Правка» без изменений вернётся мгновенно.
            editMode();
            setEditorText(S.src || editorText());
            paint(true);
            return;
        }
        S.view = v; save('view', v);
        if (S.mode === 'edit' && (!S.plan || stale())) { run('view', v); return; }
        S.mode = v;
        paint(true);
    }

    var meterTimer = 0;
    function init() {
        buildMoreList();
        syncGoalUi();

        var ed = $('tsEd');
        if (ed) {
            ed.addEventListener('input', function () {
                if (S.mode === 'clean') {
                    S.manual = true;
                    S.manualText = editorText();
                    updateMeter();
                    return;
                }
                if (S.mode !== 'edit') return;
                // Длинный текст считается не на каждой букве, а после паузы.
                clearTimeout(meterTimer);
                var len = editorText().length;
                meterTimer = setTimeout(function () {
                    var text = editorText();
                    S.lang = window.TSTrim ? window.TSTrim.detectLang(text, PAGE_LANG) : PAGE_LANG;
                    if (syncRuleTarget(text)) { syncGoalUi(); refreshChips(); }
                    updateMeter(); paintOverflow(); reveal(); renderLadder(); renderMsg(); syncAi();
                }, len > 20000 ? 250 : 60);
            });
            ed.addEventListener('paste', function (e) {
                if (S.mode === 'diff') { e.preventDefault(); return; }
                var data = e.clipboardData && e.clipboardData.getData('text/plain');
                if (data) {
                    e.preventDefault();
                    document.execCommand('insertText', false, data.replace(/\r\n?/g, '\n'));
                }
                if (S.mode !== 'edit') return;
                setTimeout(function () { afterNewText('paste'); }, 0);
            });
            ed.addEventListener('click', onCanvasActivate);
            ed.addEventListener('keydown', function (e) {
                if ((e.ctrlKey || e.metaKey) && e.key === 'Enter') {
                    e.preventDefault();
                    onMain();
                    return;
                }
                if (S.mode !== 'diff') return;
                if (e.key !== 'Enter' && e.key !== ' ') return;
                if (!e.target.closest || !e.target.closest('[data-op],[data-s],[data-gap]')) return;
                e.preventDefault();
                onCanvasActivate(e);
            });
        }

        var num = $('tsTarget');
        if (num) {
            var numTimer = 0;
            var commitNum = function () {
                var v = parseInt(num.value, 10);
                if (!(v > 0)) return;
                setGoal(v, S.goal.u, S.goal.u === 'chars' && S.goal.r === 'x' ? 'x' : null, null, 'number');
            };
            num.addEventListener('input', function () { clearTimeout(numTimer); numTimer = setTimeout(commitNum, 380); });
            num.addEventListener('change', function () { clearTimeout(numTimer); commitNum(); syncGoalUi(); });
            num.addEventListener('keydown', function (e) {
                if (e.key === 'Enter') { e.preventDefault(); clearTimeout(numTimer); commitNum(); if (!S.plan) run('user'); }
            });
        }

        var range = $('tsRange');
        if (range) {
            range.addEventListener('input', function () {
                var v = parseInt(range.value, 10) || 1;
                var keepRule = S.goal.r === 'x' ? 'x' : null;
                setGoal(v, S.goal.u, keepRule, null, 'range');
                if (!S.plan && sourceText().trim()) run('range');
            });
            range.addEventListener('change', function () { ae('range', { u: S.goal.u, n: S.goal.n }); });
        }

        bindSeg('tsUnits', 'data-u', function (u) {
            if (u === S.goal.u) return;
            ae('unit', { u: u });
            setGoal(defaultFor(u), u, null, null, 'unit');
            if (!S.plan && sourceText().trim()) run('unit');
        });
        bindSeg('tsViews', 'data-view', pickView);

        document.addEventListener('click', function (e) {
            var c = e.target.closest && e.target.closest('[data-copy]');
            if (c) { copyVersion(c.getAttribute('data-copy')); return; }
            var p = e.target.closest && e.target.closest('[data-preset]');
            if (p) applyPreset(p.getAttribute('data-preset'));
        });
        var more = $('tsMore');
        if (more) more.addEventListener('toggle', function (e) { if (e.newState === 'open') refreshMore(); });

        var ladder = $('tsLadder');
        if (ladder) ladder.addEventListener('change', onLadderChange);

        var main = $('tsRun'); if (main) main.addEventListener('click', onMain);
        var dl = $('tsTxt'); if (dl) dl.addEventListener('click', downloadOut);
        var clr = $('tsClear'); if (clr) clr.addEventListener('click', clearAll);
        var aib = $('tsAi'); if (aib) aib.addEventListener('click', aiRun);
        var pst = $('tsPaste'); if (pst) pst.addEventListener('click', pasteFromClipboard);
        var smp = $('tsSample');
        if (smp) smp.addEventListener('click', function () {
            setEditorText(CFG.sample || '');
            ae('sample', {});
            afterNewText('sample');
        });
        bindUploader();

        paint(false);
        refreshChips();

        window.addEventListener('pagehide', function () {
            if (S.plan && !S.delivered) ae('left_without_result', { regime: S.plan.regime, unit: S.goal.u, ai: S.ai ? 1 : 0 });
        });

        window.__tsDebug = {
            get plan() { return S.plan; },
            get output() { return resultText(); },
            get mode() { return S.mode; },
            get lang() { return S.lang; },
            get goal() { return Object.assign({}, S.goal); },
            get drop() { return Object.keys(S.drop).filter(function (k) { return S.drop[k]; }).map(Number); },
            get ai() { return S.ai ? { prev: S.ai.prev.length, key: S.ai.key, cost: S.ai.cost } : null; },
            get ticket() { return S.ticketKey; },
        };
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
})();
